import React, { useState } from 'react';
import '../assets/css/Category_Selector_Large.css';

const Category_Selector_Large = (props) => {

    const { categories, setActiveTabCurrent } = props;

    const [step, setStep] = useState(1);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [selectedSubcategory, setSelectedSubcategory] = useState(null);
    const [selectedSubSubcategory, setSelectedSubSubcategory] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');

    const handleCategorySelect = (category) => {
        setSelectedCategory(category);
        setStep(2);
        setSearchTerm('');
    };

    const handleSubcategorySelect = (subcategory) => {
        setSelectedSubcategory(subcategory);
        setStep(3);
        setSearchTerm('');
    };

    const handleEndLevelSelect = (subSubcategory) => {
        setSelectedSubSubcategory(subSubcategory);

        document.getElementById("cat_id").value = String(subSubcategory.id);
        // alert(subSubcategory.id);
        // alert(subSubcategory.name);
    };

    const handle_back_step_show = (stepnumber) => {
        document.getElementById("cat_id").value = "";
        setStep(stepnumber)
    };

    const filteredCategories = (categories) => {
        const term = searchTerm.trim().toLowerCase();
        if (!term) return categories;

        const filterCategory = (category) => {
            if (
                category.name.toLowerCase().includes(term) ||
                (category.keywords || []).some(keyword => keyword.toLowerCase().includes(term))
            ) {
                return true;
            }
            if (category.subcategories) {
                for (const subcategory of category.subcategories) {
                    if (filterCategory(subcategory)) {
                        return true;
                    }
                }
            }
            return false;
        };

        const filterCategories = (categories) => {
            return categories
                .map(category => ({
                    ...category,
                    subcategories: category.subcategories
                        ? filterCategories(category.subcategories)
                        : []
                }))
                .filter(filterCategory);
        };

        return filterCategories(categories);
    };

    return (
        <div style={{ padding: '20px', fontFamily: 'iran' }}>
            <input
                className={"box_search_cat_panel"}
                type="text"
                placeholder="جستجو..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                style={{
                    padding: '10px',
                    margin: '10px 0',
                    width: '100%',
                    boxSizing: 'border-box'
                }}
            />
            {step === 1 && (
                <div>
                    {filteredCategories(categories).map(category => (
                        <button
                            type="button"
                            key={category.id}
                            onClick={() => handleCategorySelect(category)}
                            className={'btn-selector-cat-large'}
                        >
                            <span>{category.name}</span>
                            <svg fill="#000000" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="25px" height="25px" viewBox="0 0 100 100" enableBackground="new 0 0 100 100" xmlSpace="preserve"><g id="SVGRepo_bgCarrier" strokeWidth={0} /><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" /><g id="SVGRepo_iconCarrier"> <g> <path d="M33.934,54.458l30.822,27.938c0.383,0.348,0.864,0.519,1.344,0.519c0.545,0,1.087-0.222,1.482-0.657 c0.741-0.818,0.68-2.083-0.139-2.824L37.801,52.564L64.67,22.921c0.742-0.818,0.68-2.083-0.139-2.824 c-0.817-0.742-2.082-0.679-2.824,0.139L33.768,51.059c-0.439,0.485-0.59,1.126-0.475,1.723 C33.234,53.39,33.446,54.017,33.934,54.458z" /> </g> </g></svg>
                        </button>
                    ))}
                </div>
            )}
            {step === 2 && selectedCategory && (
                <div>
                    <button
                        type="button"
                        onClick={() => handle_back_step_show(1)}
                        className="btn-back"
                    >
                        بازگشت
                    </button>
                    {filteredCategories(selectedCategory.subcategories).map(subcategory => (
                        <button
                            type="button"
                            key={subcategory.id}
                            onClick={() => handleSubcategorySelect(subcategory)}
                            className={'btn-selector-cat-large '}
                        >
                            <span>{subcategory.name}</span>
                            <svg fill="#000000" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="25px" height="25px" viewBox="0 0 100 100" enableBackground="new 0 0 100 100" xmlSpace="preserve"><g id="SVGRepo_bgCarrier" strokeWidth={0} /><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" /><g id="SVGRepo_iconCarrier"> <g> <path d="M33.934,54.458l30.822,27.938c0.383,0.348,0.864,0.519,1.344,0.519c0.545,0,1.087-0.222,1.482-0.657 c0.741-0.818,0.68-2.083-0.139-2.824L37.801,52.564L64.67,22.921c0.742-0.818,0.68-2.083-0.139-2.824 c-0.817-0.742-2.082-0.679-2.824,0.139L33.768,51.059c-0.439,0.485-0.59,1.126-0.475,1.723 C33.234,53.39,33.446,54.017,33.934,54.458z" /> </g> </g></svg>
                        </button>
                    ))}
                </div>
            )}
            {step === 3 && selectedSubcategory && (
                <div>
                    <button
                        type="button"
                        onClick={() => handle_back_step_show(2)}
                        className="btn-back"
                    >
                        بازگشت
                    </button>
                    {filteredCategories(selectedSubcategory.subcategories).map(subSubcategory => (
                        <button
                            type="button"
                            key={subSubcategory.id}
                            className={`btn-selector-cat-large ${selectedSubSubcategory && selectedSubSubcategory.id === subSubcategory.id ? 'selected' : ''}`}
                            onClick={() => handleEndLevelSelect(subSubcategory)}
                        >
                            <span>{subSubcategory.name}</span>
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
};

export default Category_Selector_Large;
